import React from "react";
import PropTypes from "prop-types";
import { TableRow, TableCell, Box, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import TableSortIcon from "../../components/Table/TableSortIcon";

const useStyles = makeStyles(theme => ({
  header: {
    background: theme.gradient
  },
  headerText: {
    marginRight: theme.spacing(1.75)
  }
}));

function MessagesHead(props) {
  const classes = useStyles();
  const [sort, setSort] = React.useState({ column: "date", direction: "desc" });

  const changeSortOrder = newColumn => {
    let newDirection = "asc";
    if (newColumn === sort.column) {
      newDirection = sort.direction === "asc" ? "desc" : "asc";
    }
    setSort({ column: newColumn, direction: newDirection });
    props.onSort({ sortBy: newColumn, sortDirection: newDirection });
  };

  return (
    <TableRow className={classes.header}>
      <TableCell padding="checkbox" />
      <TableCell>
        <Box display="flex" color="white">
          <Typography variant="subtitle2" className={classes.headerText}>
            Subject
          </Typography>
          <TableSortIcon
            className={classes.sortIcon}
            sortDirection={sort.column === "subject" ? sort.direction : ""}
            onClick={() => changeSortOrder("subject")}
          />
        </Box>
      </TableCell>
      <TableCell>
        <Box display="flex" color="white">
          <Typography variant="subtitle2" className={classes.headerText}>
            From
          </Typography>
          <TableSortIcon
            className={classes.sortIcon}
            sortDirection={sort.column === "from" ? sort.direction : ""}
            onClick={() => changeSortOrder("from")}
          />
        </Box>
      </TableCell>
      <TableCell>
        <Box display="flex" color="white">
          <Typography variant="subtitle2" className={classes.headerText}>
            Date
          </Typography>
          <TableSortIcon
            sortDirection={sort.column === "date" ? sort.direction : ""}
            onClick={() => changeSortOrder("date")}
          />
        </Box>
      </TableCell>
    </TableRow>
  );
}

MessagesHead.propTypes = {
  onSort: PropTypes.func
};

export default MessagesHead;
